function initMonogramming(){

  // preview elements
  const previewBox = document.getElementById('preview-box');
  const previewText = document.getElementById('preview-text');
  const goldPreview = document.getElementById('gold-foil-preview');
  const HPPreview = document.getElementById('hand-painting-preview');
  const embroideryPreview = document.getElementById('embroidery-preview');
  
  // 
  const embroideryBox = document.getElementById('emb-box');
  const goldInput = document.getElementById('gold-letter-input');
  const HPInput = document.getElementById('hp-letter-input');
  const embroideryInput = document.getElementById('emb-letter-input');       
  const monogramInputs = [goldInput, HPInput, embroideryInput]
  const left = document.getElementById('preview-text-left');
  const right = document.getElementById('preview-text-right');
  const block = document.getElementById('preview-text-block');
  const price = document.getElementById('price');
  const tabs = document.getElementsByClassName("tab-label tab__summary");
  const goldNotes = document.getElementById('gold-foil-notes');
  const HPNotes = document.getElementById('hand-painting-notes');
  const embroideryNotes = document.getElementById('embroidery-notes');
  const embroideryNotice = document.getElementById('em-notice');
  const goldLabel = document.getElementById('gold-letter-label');
  const HPLabel = document.getElementById('hp-letter-label');
  const embroideryLabel = document.getElementById('emb-letter-label');

  const goldNotice = document.getElementById('gold-notice');
  const hpNotice = document.getElementById('hp-notice');
  const goldFonts = document.getElementById('gold-fonts');
  const goldPhraseSelect = document.getElementById('gold-phrase');
  if (goldPhraseSelect) {
    goldPhraseSelect.addEventListener('change', handleGoldPhrase);
  }

  const HPSizeRadios = document.querySelectorAll('input[type=radio][name="size"]');
  const embroideryFont = document.getElementById('emb-font');
  const embroideryCombo = document.getElementById('emb-combo-swatches');
  const embroideryColor = document.getElementById('emb-color-swatches');
  let embroideryStyle = 'color';
  let activeTab = tabs[0].getAttribute('aria-controls');
  const goldPlacement = document.getElementById('gold-placement');
  const hpPlacement = document.getElementById('hp-placement');
  const embroideryPlacement = document.getElementById('emb-placement');
  const examplesLink = document.getElementById('view-examples');
  
  Array.prototype.forEach.call(HPSizeRadios, function(radio) {
    radio.addEventListener('change', handleHPSizeChange);
  });
  const goldTypeRadios = document.querySelectorAll('input[type=radio][name="gold-type"]');
  Array.prototype.forEach.call(goldTypeRadios, function(radio) {
    radio.addEventListener('change', handleGoldTypeChange);
  });
  var goldFontRadios = document.querySelectorAll('input[type=radio][name="font"]');
  Array.prototype.forEach.call(goldFontRadios, function(radio) {
    radio.addEventListener('change', handleGoldFontChange);
  });
  let oneInchMax = 0;
  let twoInchMax = 0;

  const timelinesJSON = JSON.parse(document.querySelector('[data-monogramming-timelines]').textContent);

  if(activeTab === 'tab-gold-foil'){
    computeGoldPrice();
  } else if(activeTab === 'tab-hand-painting') {
    computeHPPrice();
  } else {
    computeEmbroideryPrice();
  }

  // Initial setup 
  updateFAQ();
  updateImage();
  updateExamplesLink();
  addColorSwatchesClickEvents();
  if (goldPlacement) {
    goldPlacement.addEventListener('change', handleGoldPlacementChange);
    handleGoldPlacementChange();
  }
  if (hpPlacement) {
    hpPlacement.addEventListener('change', handleHPPlacementChange);
    initializeHP();
    handleHPPlacementChange();
  }
  if (embroideryPlacement) {
    embroideryPlacement.addEventListener('change', handleEmbroideryPlacementChange);
    handleEmbroideryPlacementChange();
  }
  if (embroideryFont) {
    embroideryFont.addEventListener('change', handleEmbroideryFont);
    handleEmbroideryFont();
  }
  
  // Tab logic
  $(document).off("click.monogram", ".tab-label").on("click.monogram", ".tab-label", function (event) {
    event.preventDefault();

    var $this = $(this);
    activeTab = this.getAttribute('aria-controls');
    $this.parents(".tabs-container").find(".tab-label").removeClass("active");
    $this.addClass("active").siblings().removeClass("active");
    //clear inputs and reset preview styles on tab change
    monogramInputs.forEach(input => {
      // original build adds inputs even when they do not exist
      if (input != null) {
        input.value = '';
        input.dispatchEvent(new Event('input'));
      }
    });
    goldPhraseSelect.value = '';
    previewText.style.fontSize = "30px";
    previewText.style.textShadow = "none";
    left.style.color = null;
    right.style.color = null;
    updateFAQ();
    updateImage();
    updateExamplesLink();
    updateComputedPrice();
  });


  var toggleTabs = function () {
    var s = {
      $summary: $(".tab__summary"),
      $content: $(".tab__content"),
    };

    var bindUI = function () {
      s.$summary.on("click", function (e) {
        var $self = $(this);

        var data = {
          controls: $self.attr("aria-controls"),
        };

       toggleTab(data.controls);
      });
    };

    var toggleTab = function (controls) {
      if (tabIsHidden(controls) == "true") {
        hideTab(); // Hide all
        showTab(controls); // Show specific
      }
    };

    var tabIsHidden = function (controls) {
      return s.$content.filter("[id='" + controls + "']").attr("aria-hidden");
    };

    var hideTab = function (controls) {
      if (controls) {
        s.$summary
          .filter("[aria-controls='" + controls + "']")
          .attr("aria-selected", "false");

        s.$content
          .filter("[id='" + controls + "']")
          .attr("aria-hidden", "true")
          .hide();
      } else {
        s.$summary.attr("aria-selected", "false");
        s.$content.attr("aria-hidden", "true").hide();
        s.$content.find("input").find("select").find("textarea").find("a").find("button").attr("tab-index", -1);
      }

      $(".option-set-col").removeClass("active");
    };

    var showTab = function (controls) {
      if (controls) {
        s.$summary
          .filter("[aria-controls='" + controls + "']")
          .attr("aria-selected", "true");

        s.$content
          .filter("[id='" + controls + "']")
          .attr("aria-hidden", "false")
          .show();
      } else {
        s.$summary.attr("aria-selected", "true");
        s.$content.attr("aria-hidden", "false").show();
        s.$content.find("input").find("select").find("textarea").find("a").find("button").attr("tab-index", 0);
      }

      s.$content
        .filter("[id='" + controls + "']")
        .parent(".option-set-col")
        .addClass("active");
    };

    var init = function () {
      bindUI();
      hideTab();
      showTab($($(".tab__summary")[0]).attr("aria-controls"));
      $($(".tab__summary")[0]).addClass("active");
    };

    init();
  };
  toggleTabs();

  // Helper functions
  function updateComputedPrice(){
    if(activeTab === 'tab-embroidery'){
      computeEmbroideryPrice();
    } else if (activeTab === 'tab-hand-painting'){
      computeHPPrice();
    }
    else {
      computeGoldPrice();
    }
  }

  function updateImage(){
    if(activeTab === 'tab-embroidery'){
      previewBox.style.display = 'none';
      embroideryBox.style.display = 'flex';
      embroideryPreview.style.display = 'block';
      goldPreview.style.display = 'none';
      HPPreview.style.display = 'none';
    } else if (activeTab === 'tab-hand-painting'){
      previewBox.style.display = 'flex';
      embroideryBox.style.display = 'none';
      HPPreview.style.display = 'block';
      embroideryPreview.style.display = 'none';
      goldPreview.style.display = 'none';
    }
    else {
      previewBox.style.display = 'flex';
      embroideryBox.style.display = 'none';
      goldPreview.style.display = 'block';
      embroideryPreview.style.display = 'none';
      HPPreview.style.display = 'none';
    }
  }

  function updateFAQ(){
    if(activeTab === 'tab-gold-foil'){
      goldNotes.style.display = 'block';
      HPNotes.style.display = 'none';
      embroideryNotes.style.display = 'none';
      goldNotice.style.display = 'block';
      hpNotice.style.display = 'none';
      embroideryNotice.style.display = 'none';
    } else if (activeTab === 'tab-hand-painting'){
      goldNotes.style.display = 'none';
      HPNotes.style.display = 'block';
      embroideryNotes.style.display = 'none';
      goldNotice.style.display = 'none';
      hpNotice.style.display = 'block';
      embroideryNotice.style.display = 'none';
    } else {
      goldNotes.style.display = 'none';
      HPNotes.style.display = 'none';
      embroideryNotes.style.display = 'block';
      embroideryNotice.style.display = 'block';
      goldNotice.style.display = 'none';
      hpNotice.style.display = 'none';
    }
  }

  function addPreviewText(str, placement){
    if(window.MonogrammingOptions.isStriped && placement.includes('center')){
      let strArray = str.split("");
      block.style.display = 'none';
      left.style.display = 'block';
      right.style.display = 'block';
      previewBox.className = "";
      if(placement){
        previewBox.classList.add(placement);
      }
      left.innerHTML = '';
      right.innerHTML = '';
      for(let i = 0; i < strArray.length; i++){
        if(i % 2 === 0){
          left.innerHTML += strArray[i].toUpperCase();
        } else {
          right.innerHTML += strArray[i].toUpperCase();
        }
      }
    } else {
      left.style.display = 'none';
      right.style.display = 'none';
      previewBox.className = "";
      if(placement){
        previewBox.classList.add(placement);
      }
      // Special case where the heart ascii turns into an emoji in ios devices, this inserts it as unicode character with no color, to avoid the emoji.
      if ( str.length == 1 && str.charCodeAt(0) == 0x2665 ) {
        block.innerText = '\u{2665}\u{fe0e}';
      } else {
        block.innerHTML = str.toUpperCase();
      }
      block.style.display = 'block';
    }
  }

  function handleFormFields(str, tab){
    const formSections = document.getElementById(tab).querySelectorAll('.can-disable');
    if(str){
      formSections.forEach(element => {
        element.classList.remove('disabled');
        element.setAttribute('aria-disabled', 'false');
        element.setAttribute('aria-label', '');
      });
    } else {
      formSections.forEach(element => {
        element.classList.add('disabled');
        element.setAttribute('aria-disabled', 'true');
        element.setAttribute('aria-label', 'Enter characters first to enable this section');
      });
    }
  }

  function updatePreviewFont(font){
    previewText.style.fontSize = '25px';
    if(font === 'short'){
      previewText.style.fontFamily = 'BankGothic';
      previewText.style.fontSize = '30px';
    } else if (font === 'tall') {
      previewText.style.fontFamily = 'Empire';
      previewText.style.fontSize = '60px';
    } else {
      previewText.style.fontFamily = 'NewsGothic';
    }
  }

    /**
      * Replaces invalid characters for valid ones
    */
    function sanitizeText( letters, regexString ) {
    var replacements = [];
    for ( var i = 0; i < letters.length; i++ ) {
      if ( !validateCharacter( letters[ i ], regexString ) ) {
        replacements.push( letters[ i ] );
      }
    }
    for ( var i = 0; i < replacements.length; i++ ) {
      letters = letters.replace( replacements[ i ], '' );
    }

    return letters;
  }

  function validateCharacter( char, regexString ) {
    var regexp = new RegExp( regexString );
    return regexp.test(char);
  }

  //GOLD FOIL SECTION
  function handleGoldPhrase() {
    previewText.style.color = '#E9BD7D';
    let text = goldPlacement.value.substr(0, goldPlacement.value.indexOf('('));
    let selectedPhrase = goldPhraseSelect.value;
    updatePreviewFont(window.MonogrammingOptions.phraseFont);
    addPreviewText(selectedPhrase, text);
    handleFormFields(selectedPhrase, 'tab-gold-foil');
  }

  function handleGoldPlacementChange () {
    if(goldPlacement.value === '' && goldPlacement.options[1]){
      goldPlacement.options[1].selected = true;
    }
    let placement = goldPlacement.value.substr(0, goldPlacement.value.indexOf('('));
    //extracting content between brackets
    let regExp = /\(([^)]+)\)/;
    let matches = regExp.exec(goldPlacement.value);
    let limit;

    if(matches){
      limit =  matches[1];
    }

    let value = document.querySelector('input[name="gold-type"]:checked').value;
    if(value === 'initial'){
      goldInput.value = goldInput.value.substring(0,limit)
      goldInput.dispatchEvent(new Event('input'));
      goldInput.maxLength = limit;
      goldInput.placeholder = `Enter up to ${limit} characters (A-Z, 0-9)`;
      
    } else {
      handleGoldPhrase();
    }
  }

  function handleGoldTypeChange() {
    computeGoldPrice();
    let value = document.querySelector('input[name="gold-type"]:checked').value;
    goldInput.value = '';
    goldInput.dispatchEvent(new Event('input'));
    goldPhraseSelect.value = '';

    if(value === 'initial'){
      block.style.display = 'none';
      handleFormFields(goldInput.value, 'tab-gold-foil');
      goldInput.style.display = 'block';
      goldPhraseSelect.style.display = 'none';
      goldFonts.style.display = 'block';
    } else {
      goldPhraseSelect.style.display = 'block';
      goldInput.style.display = 'none';
      goldFonts.style.display = 'none';
    }
  }

  if (goldInput) {
    goldInput.addEventListener('input', handleGoldPreview);
  }

  function handleGoldPreview(e) {
    let placement = goldPlacement.value.substr(0, goldPlacement.value.indexOf('('));
    let fontVvalue = document.querySelector('input[name="font"]:checked').value;
    let sanitizedText;
    if(fontVvalue === 'tall'){
      sanitizedText = sanitizeText( e.target.value, '[A-Za-z]');
    } else if(fontVvalue === 'short'){
      sanitizedText = sanitizeText( e.target.value, '[A-Za-z0-9.,]');
    } else {
      sanitizedText = sanitizeText( e.target.value, '[A-Za-z0-9.,♥]');
    }
    goldInput.value = sanitizedText;
    computeGoldPrice();
    handleFormFields(sanitizedText, 'tab-gold-foil');
    addPreviewText(sanitizedText, placement);
    updatePreviewFont(fontVvalue);
    previewText.style.color = '#FCD478';
    previewText.classList.remove('hp');
    previewText.classList.remove('hp-2inch');
    goldLabel.style.color = 'inherit';
  }

  function getGoldPriceObjectByName() {
    const setPrice = window.MonogrammingOptions.goldFoilPrice;
    for ( const displayPrice in window.MonogrammingOptions.monogrammingVariantsByPrice ) {
      if ( parseInt(window.MonogrammingOptions.monogrammingVariantsByPrice[displayPrice].name) === setPrice ) {
        return window.MonogrammingOptions.monogrammingVariantsByPrice[displayPrice];
      }
    } 
  }


  function computeGoldPrice(){
    let type = document.querySelector('input[name="gold-type"]:checked').value;
    let computedPrice;
    if(type === 'initial'){
      if(window.MonogrammingOptions.freeAvailable){
        computedPrice = 0;
        price.innerHTML = displayPrice(0);
      }
      else if(goldInput.value.length >= 0){
        computedPrice = getGoldPriceObjectByName().price;
        price.innerHTML = displayPrice(computedPrice);  
      }
    } else {
      computedPrice = getGoldPriceObjectByName().price;
      price.innerHTML = displayPrice(computedPrice);
    }
    return computedPrice;
  }

    function handleGoldFontChange() {
      goldInput.dispatchEvent(new Event('input'));
    }
    
    //HAND PAINTING SECTION
    const blue = '#4C9DBD';
    const poppy = '#DE5740';
    const black = '#53443E';
    const cream = '#FBFBED';
    const green = '#08623E';
    const lavender = '#A8A1E9';
    if (HPInput) {
      HPInput.addEventListener('input', handleHPPreview);
    }
    const hpFirstColor = document.getElementById('hp-first-color');
    if (hpFirstColor) {
      hpFirstColor.addEventListener('change', handleFirstColorSelection);
    }
    const hpSecondColor = document.getElementById('hp-second-color');
    if (hpSecondColor) {
      hpSecondColor.addEventListener('change', handleSecondColorSelection);
    }

    const HPShadowRadios = document.querySelectorAll('input[type=radio][name="shadow"]');
    Array.prototype.forEach.call(HPShadowRadios, function(radio) {
      radio.addEventListener('change', handleHPShadowChange);
    });

    function computeHPPrice(){
      let computedPrice = 0;
      if(HPInput.value.length === 0){
        computedPrice = window.MonogrammingOptions.handPaintedBasePrice;
        price.innerHTML = displayPrice(computedPrice);
      }
      else if(HPInput.value.length > 0 ){
        let sum = window.MonogrammingOptions.handPaintedBasePrice;
        let strArray = HPInput.value.split("");
        if(strArray.length > 1){
          for (let index = 1; index < strArray.length; index++) {
            sum +=  window.MonogrammingOptions.handPaintedAddPrice;;
          }
        }
        computedPrice = sum;
        price.innerHTML = displayPrice(sum);
      } 
      return computedPrice;
    }

    function handleHPPreview(e) {
      let placement = hpPlacement.value.substr(0, hpPlacement.value.indexOf('('));
      let sanitizedText = sanitizeText( e.target.value, '[A-Za-z]' );
      HPInput.value = sanitizedText;
      setUIbySize();
      computeHPPrice();
      handleFormFields(sanitizedText, 'tab-hand-painting');
      addPreviewText(sanitizedText, placement);
      handleFirstColorSelection();
      handleSecondColorSelection();
      handleHPSizeChange();
      handleHPShadowChange();
      previewText.style.fontFamily = 'SayaHand';
      previewText.classList.add('hp');
      HPLabel.style.color = 'inherit';
    }

    function initializeHP () {
      if(hpPlacement.value === '' && hpPlacement.options[1]){
        hpPlacement.options[1].selected = true;
      }
      
      //extracting content between brackets
      let regExp = /\(([^)]+)\)/;
      let sizeRadios = document.getElementsByClassName('radio size_radios');

      [...hpPlacement.options].forEach(option => {
        let val = regExp.exec(option.value);
        if(option.value){
          let oneInchValue = val[1].split('-')[0];
          let twoInchValue = val[1].split('-')[1];
          if(oneInchValue > oneInchMax){
            oneInchMax = oneInchValue;
          }
          if(twoInchValue > twoInchMax){
            twoInchMax = twoInchValue
          }
        }
      })

      for (let radio of sizeRadios) {
        if (!radio.classList.contains('disabled')) {
          document.getElementById(radio.getAttribute('for')).checked = true;
          break;
        }
      }
      setUIbySize();
    }

    function setUIbySize() {
      let regExp = /\(([^)]+)\)/;
      let value = document.querySelector('input[name="size"]:checked').value;
      let textValue = HPInput.value;
      let matches = regExp.exec(hpPlacement.value);
      let oneInchRadio = document.getElementById('one-inch-label');
      let twoInchRadio = document.getElementById('two-inch-label');

      if(textValue.length > oneInchMax){
        oneInchRadio.classList.add('disabled');
        } else {
        oneInchRadio.classList.remove('disabled');
        }

      if(textValue.length > twoInchMax){
        twoInchRadio.classList.add('disabled');
        } else {
          twoInchRadio.classList.remove('disabled');
        }

      if(value === 'one_inch'){
        [...hpPlacement.options].forEach(option => {
          if(option.value){
            let matches2 = regExp.exec(option.value);
            let size_12 = matches2[1].split('-')[0];
            let text = option.value.substr(0, option.value.indexOf('(')).replace(/-/g, ' ').replace(/^./, function(x){return x.toUpperCase()})
            option.text = `${text} (Max ${size_12} letters)`;
            if(size_12 == 0){
              option.disabled = true;
              option.selected = false;
            }
            if(textValue.length > size_12){
              option.disabled = true;
              option.selected = false;
            } else {
              option.disabled = false;
            }
          }
        });
        if(hpPlacement.value){
          let placementValue = regExp.exec(hpPlacement.value);
          let size_1 = placementValue[1].split('-')[0];
          HPInput.maxLength = size_1;
          HPInput.placeholder = `Enter up to ${size_1} letters (A-Z)`;
          HPInput.value = HPInput.value.substring(0,size_1);
        } else {
          [...hpPlacement.options].forEach(option => {
            if(!option.disabled){
              option.selected = true;
            }
          })
        }
      } else if (value === 'two_inch') {
        [...hpPlacement.options].forEach(option => {
          if(option.value){
            let matches3 = regExp.exec(option.value);
            let size_22 = matches3[1].split('-')[1];
            let text = option.value.substr(0, option.value.indexOf('(')).replace(/-/g, ' ').replace(/^./, function(x){return x.toUpperCase()})
            option.text = `${text} (Max ${size_22} letters)`;
            if(textValue.length > size_22){
              option.disabled = true;
              option.selected = false;
            } else {
              option.disabled = false;
            }
          }
        });
        if(hpPlacement.value){
          let placementValue_2 = regExp.exec(hpPlacement.value);
          let size_2 = placementValue_2[1].split('-')[1];
          HPInput.maxLength = size_2;
          HPInput.placeholder = `Enter up to ${size_2} characters (A-Z, 0-9)`;
          HPInput.value = HPInput.value.substring(0,size_2);
        } else {
          [...hpPlacement.options].forEach(option => {
            if(!option.disabled){
              option.selected = true;
            }
          })
        }
      } 
    }
    function handleHPPlacementChange () {
      setUIbySize();
      let placement = hpPlacement.value.substr(0, hpPlacement.value.indexOf('('));
      let sanitizedText = sanitizeText( HPInput.value, '[A-Za-z]' );
      addPreviewText(sanitizedText, placement);
    }

    function handleFirstColorSelection () {
      let color = hpFirstColor.value;
      const secondColorSwatchContainer = document.querySelector('.swatch-container[data-select="hp-second-color"]');
      const noColorSwatch = secondColorSwatchContainer.lastElementChild;

      let secondColorSelect = hpSecondColor.getElementsByTagName("option");
        for (var i = 0; i < secondColorSelect.length; i++) {
          const colorSwatch = secondColorSwatchContainer.querySelector(`[data-color="${secondColorSelect[i].value.toLowerCase()}"]`);
          if(i == 0){
            continue;
          }
          if ( secondColorSelect[i].value.toLowerCase() == color ) {
            secondColorSelect[i].disabled = true;
            colorSwatch.classList.add('disabled');

            // If the second color is the same as the selected first color. Make the second color the no drop shadow option
            if ( colorSwatch.classList.contains('selected') ) {
              const displayLabel = document.getElementById('hp-second-color-display');

              displayLabel.innerHTML = noColorSwatch.dataset.label;
              colorSwatch.classList.remove('selected');
              noColorSwatch.classList.add('selected');
              const noDropShadow = document.getElementById('no-drop-shadow');
              noDropShadow.checked = true;
              noDropShadow.dispatchEvent(new Event('change'));
            }
          } else {
            secondColorSelect[i].disabled = false ;
            colorSwatch.classList.remove('disabled');
          }
        }

      switch (color) {
        case "blue":
          previewText.style.color = blue;
          break;
        case "black":
          previewText.style.color = black;
          break;
        case "cream":
          previewText.style.color = cream;;
          break;
        case "green":
          previewText.style.color = green;
          break;
        case "poppy":
          previewText.style.color = poppy;
          break;
        case "lavender":
          previewText.style.color = lavender;
          break;
        default:
      }

    }

    function handleSecondColorSelection () {
      let color = hpSecondColor.value;

      let op = hpFirstColor.getElementsByTagName("option");
      for (var i = 0; i < op.length; i++) {
        if(i == 0){
          continue;
        }
        if(!color){
           op[i].disabled = false ;
        } else {
          (op[i].value.toLowerCase() == color && color != '') 
          ? op[i].disabled = true 
          : op[i].disabled = false ;
        }
      }
      
        switch (color) {
          case "blue":
            previewText.style.textShadow = '-3px 1px ' + blue;
            break;
          case "black":
            previewText.style.textShadow = '-3px 1px ' + black;
            break;
          case "cream":
            previewText.style.textShadow = '-3px 1px ' + cream;
            break;
          case "green":
            previewText.style.textShadow = '-3px 1px ' + green;
            break;
          case "poppy":
            previewText.style.textShadow = '-3px 1px ' + poppy;
            break;
          case "lavender":  
            previewText.style.textShadow = '-3px 1px ' + lavender;
            break;
          default:
        }
      }

      function handleHPSizeChange() {
        let value = document.querySelector('input[name="size"]:checked').value;
        previewText.classList.remove('hp-2inch');
        if(value === 'one_inch'){
          previewText.style.fontSize = '65px';
        } else if (value === 'two_inch') {
          previewText.style.fontSize = '115px';
          previewText.classList.add('hp-2inch');
        }
        setUIbySize(); 
      }
      
      function handleHPShadowChange() {
        let value = document.querySelector('input[name="shadow"]:checked').value;
        if(value === 'drop'){
          handleSecondColorSelection();
          hpSecondColor.disabled = false;
        } else if (value === 'no_drop') {
          previewText.style.textShadow = 'none';
          hpSecondColor.disabled = true;
          hpSecondColor.value = "";
          handleSecondColorSelection();
        } 
      }
      


  //EMBROIDERY SECTION
  const embTypeRadios = document.querySelectorAll('input[type=radio][name="emb-type"]');
  const embroideryGraphic = document.getElementById('emb-graphic');
  if (embroideryGraphic) {
    embroideryGraphic.addEventListener('change', handleGraphicChange);
  }
  Array.prototype.forEach.call(embTypeRadios, function(radio) {
    radio.addEventListener('change', handleEmbroideryTypeChange);
  });
  if (embroideryInput) {
    embroideryInput.addEventListener('input', handleEmbroideryPreview);
  }

  function handleEmbroideryFont(){
    if(embroideryFont.value === '' && embroideryFont.options[1]){
      embroideryFont.options[1].selected = true;
    }
    let font = embroideryFont.value;
    
    if(font === 'block'){
      embroideryCombo.style.display = 'block';
      embroideryColor.style.display = 'none';
      embroideryStyle = 'combo';
      embroideryBox.style.backgroundImage = `url("//${window.MonogrammingOptions.blockWithShadowImage}")`;
    } else if (font === 'block-without-shadow') {
      embroideryCombo.style.display = 'none';
      embroideryColor.style.display = 'block';
      embroideryStyle = 'color';
      embroideryBox.style.backgroundImage = `url("//${window.MonogrammingOptions.blockWithoutShadowImage}")`;
    } else if (font === 'script') {
      embroideryCombo.style.display = 'none';
      embroideryColor.style.display = 'block';
      embroideryStyle = 'color';
      embroideryBox.style.backgroundImage = `url("//${window.MonogrammingOptions.scriptImage}")`;
    }
    if(document.querySelector('input[name="emb-type"]:checked')){
      let value = document.querySelector('input[name="emb-type"]:checked').value;

      if(value === 'graphic'){
        embroideryBox.style.backgroundImage = `url("//${window.MonogrammingOptions.lipsImage}")`;
      }
    }
  }

  function handleGraphicChange(){
    computeEmbroideryPrice(); 
  }

  function computeEmbroideryPrice(){
    let basePrice = window.MonogrammingOptions.embroideredBasePrice;
    let addPrice = window.MonogrammingOptions.embroideredAddPrice;
    let lipPrice = window.MonogrammingOptions.embroideredLipsPrice;
    if(document.querySelector('input[name="emb-type"]:checked')){
      let value = document.querySelector('input[name="emb-type"]:checked').value;
      let computedPrice = 0;
      
      if(value === 'graphic'){
        price.innerHTML = displayPrice(basePrice);
        if(embroideryGraphic.value === 'lips'){
          computedPrice = lipPrice;
          price.innerHTML = displayPrice(lipPrice);
        }
      }
      else if(embroideryInput.value.length === 0){
        computedPrice = basePrice
        price.innerHTML = displayPrice(basePrice);
      }
      else if(embroideryInput.value.length > 0 ){
        let sum = basePrice;
        if(value === 'both' && embroideryGraphic.value === 'lips'){
          sum += lipPrice;
        }
        let strArray = embroideryInput.value.split("");
        if(strArray.length > 2){
          for (let index = 2; index < strArray.length; index++) {
            sum += addPrice;
          }
        }
        computedPrice = sum;
        price.innerHTML = displayPrice(sum);
      } 
      return computedPrice;
    } else {
      if(embroideryInput.value.length === 0){
        computedPrice = basePrice;
        price.innerHTML = displayPrice(basePrice);
      }
      else if(embroideryInput.value.length > 0 ){
        let sum = basePrice;
        let strArray = embroideryInput.value.split("");
        if(strArray.length > 2){
          for (let index = 2; index < strArray.length; index++) {
            sum += addPrice;
          }
        }
        computedPrice = sum;
        price.innerHTML = displayPrice(sum);
        return computedPrice;
      } 
    }
  }

  function handleEmbroideryTypeChange() {
    let value = document.querySelector('input[name="emb-type"]:checked').value

    if(value === 'initial'){
      embroideryInput.style.display = 'block';
      embroideryGraphic.value = "";
      embroideryGraphic.dispatchEvent(new Event('change'));
      embroideryGraphic.style.display = 'none';
      document.getElementById('emb-font-section').style.display = 'block';
      document.getElementById('emb-color-section').style.display = 'block';
    } else if (value === 'graphic'){
      embroideryGraphic.style.display = 'block';
      embroideryInput.style.display = 'none';
      embroideryInput.value = "";
      embroideryInput.dispatchEvent(new Event('input'));
      document.getElementById('emb-font-section').style.display = 'none';
      document.getElementById('emb-color-section').style.display = 'none';
    } else {
      embroideryGraphic.style.display = 'block';
      embroideryInput.style.display = 'block';
      embroideryGraphic.dispatchEvent(new Event('change'));
      document.getElementById('emb-font-section').style.display = 'block';
      document.getElementById('emb-color-section').style.display = 'block';
    }
    computeEmbroideryPrice();
    handleEmbroideryFont();
  }



  function handleEmbroideryPreview(e) {
    let sanitizedText = sanitizeText( e.target.value, '[A-Za-z]' );
    embroideryInput.value = sanitizedText;
    handleFormFields(sanitizedText, 'tab-embroidery');
    computeEmbroideryPrice();
    handleEmbroideryFont();
    embroideryLabel.style.color = 'inherit';
  }

  function handleEmbroideryPlacementChange () {
    if(embroideryPlacement.value === '' && embroideryPlacement.options[1]){
      embroideryPlacement.options[1].selected = true;
    }
    let placement = embroideryPlacement.value.substr(0, embroideryPlacement.value.indexOf('('));
    //extracting content between brackets
    let regExp = /\(([^)]+)\)/;
    let matches = regExp.exec(embroideryPlacement.value);
    if(matches){
      let limit =  matches[1];

      embroideryInput.value = embroideryInput.value.substring(0,limit)
      embroideryInput.maxLength = limit;
      embroideryInput.placeholder = `Enter up to ${limit} characters (A-Z)`;
      embroideryInput.dispatchEvent(new Event('input'));
    }
  }

  /**
   * Monogramming toggle value
   */
  var monogrammingOn = false;

  var monogramMaxLength = -1;

  // paint / font / phrase
  var currentSelectedType = null;
  var $currentSelectedElement = null;
  var currentPriceVariant = getGoldPriceObjectByName()

  // display elems
  var $monogramPriceLabel = $( '[ref="mono-price"]' );
  var $additionalPriceLabel = $( '.monogram-pop-up-price' );

  // modal
  var $modal = $( '#monogramming-modal' );

  // Custom text inputs
  var $monogramTextInput = $( "#mono-text" );
  var $monogramPlacementInput  = $( "#mono-placement" );

  $( function() {

    // close X
    $('[ref="mono-close-modal"]').click(toggleModal);
    document.querySelector('[ref="monogramming"]').addEventListener('click', function (e) {
      // if button doesn't have class 'disabled' then toggle modal
      if (!e.target.classList.contains('disabled')) {
        toggleModal(e);
      }
    });

    // Mobile-friendly label+checkbox check logic
    $( '[ref="mono-option"]' ).click( onOptionSelected );

    // Monitor monogram text changes
    $monogramTextInput.bind( 'input', onMonogramTextChanged );
    $monogramTextInput.bind( 'blur', onMonogramTextBlurred );

    // Monitor placement change
    $monogramPlacementInput.change( onPlacementChanged );

    /**
     * When ADD TO CART is tapped, the monogram (if selected) is added
     * to the cart before adding the final product using the JS API.
     */
    $( '#minicart-add-to-cart-form, #secondAdd' ).bindFirst( 'submit.monogram', submitMonogram );

    render();

  } );

  function onDocumentClick( e ) {
    if ( $( e.target ).parents( '.monogramming-wrap-container' ).length === 0 ) {
      toggleModal( e );
    }
  }

  window.emptyMonoModal = function( e ) {
    console.warn('Empty Mono Modal');
    const $monoOptions = $('li[ref="mono-option"]');
    const $inputs = $('input[name="properties[monogram-handpainted]"]');
    $inputs.attr('checked',false);
    $monoOptions.removeClass('selected');
    $monogramTextInput.hide();
    $monogramPlacementInput.hide();
    $monogramPlacementInput.prev().hide();
    $('#mono-text').val('');

  };

  window.toggleModal = function( e ) {
    e && e.stopImmediatePropagation();

    if(monogrammingOn){
      emptyMonoModal();
    }

    $modal.toggleClass( 'm-open' );
    monogrammingOn = !monogrammingOn;

    if ( window.bodyScroll ) {
      $modal.hasClass('m-open') ? window.bodyScroll.lock() : window.bodyScroll.unlock();
    }

    if ($modal.hasClass('m-open')) {
      document.body.classList.add('monogramming-open');
    }
    else {
      document.body.classList.remove('monogramming-open');
    }

    if ( monogrammingOn ) {
      $( document ).on( 'click', onDocumentClick );
    } else {
      $( document ).off( 'click', onDocumentClick );
    }
  }

  /**
   * Returns the text to be monogrammed (phrase or hand-written text)
   */
  function getSelectedMonoText() {
    return currentSelectedType === 'phrase'
      ? $currentSelectedElement.val()
      : $monogramTextInput.val()
  }

  /**
   * When placement option is changed, revalidate text
   */
  function onPlacementChanged() {
    onMonogramTextChanged.bind( $monogramTextInput[ 0 ] )();
  }

  /**
   * When a radio is selected
   */
  function onOptionSelected( e ) {
    var $selects = $( $( this ).data( 'mono-selects' ) );
    var $target = $( $selects[ 0 ] );
    $target.prop( 'checked', true );

    $( '[ref="mono-option"]' ).removeClass( 'selected' );
    $( this ).addClass( 'selected' );

    $currentSelectedElement = $target;
    var type = $( this ).data( 'mono-type' );
    currentSelectedType = type;

    // submit monogram text if applicable to re-validate it
    if ( currentSelectedType !== 'phrase' ) {
      onMonogramTextChanged.bind( $monogramTextInput[ 0 ] )();
    }

    console.log( 'selected', currentSelectedType, 'value', $currentSelectedElement.val() );

    updatePrice();
    render();
  }


  /**
   * When the monogram text changes
   */
  function onMonogramTextChanged() {
    var fontCharLimit = $currentSelectedElement.data( 'char-limit' ) || 9999;
    var placementCharLimit = $monogramPlacementInput.find('option:checked').data('max-chars') || 9999;
    var charLimit = Math.min( parseInt( fontCharLimit ), parseInt ( placementCharLimit ) );
    var validationRegex = $currentSelectedElement.data( 'regexp' );
    var text = $( this ).val();

    var sanitizedText = sanitizeMonogramText( text, charLimit, validationRegex );

    $monogramTextInput.val( sanitizedText );

    updatePrice();
    render();
  }

  /**
   * When the monogram text blurs, we remove spaces at the
   * beginning and end.
   */
  function onMonogramTextBlurred() {
    $monogramTextInput.val( $monogramTextInput.val().trim() );
    updatePrice();
    render();
  }

  /**
   * Replaces invalid characters for valid ones
   */
  function sanitizeMonogramText( letters, charLimit, regexString ) {
    var replacements = [];
    for ( var i = 0; i < letters.length; i++ ) {
      if ( !validateMonogramCharacter( letters[ i ], regexString ) ) {
        replacements.push( letters[ i ] );
      }
    }
    for ( var i = 0; i < replacements.length; i++ ) {
      letters = letters.replace( replacements[ i ], '' );
    }

    var length = letters.length;
    if ( length > charLimit ) {
      letters = letters.substring( 0, charLimit );
      length = charLimit;
    }

    return letters;
  }

  /**
   * Validates the given character of the text given a
   * validation regex
   */
  function validateMonogramCharacter( char, regexString ) {
    var regexp = new RegExp( regexString );
    return regexp.test(char);
  }

  function updatePrice() {
    var variant = getActiveMonogrammingVariant();
    currentPriceVariant = variant;
  }

  /**
   * Renders the appropiate elements given the selected
   * option
   */
  function render() {
    renderPrice();

    if ( currentSelectedType === null ) {
      renderTextInput( false );
      renderPlacement( false );
    }
    else if ( currentSelectedType === 'font' ) {
      renderTextInput( true );
      renderPlacement( true );
    }
    else if ( currentSelectedType === 'phrase' ) {
      renderTextInput( false );
      renderPlacement( false );
    }
    else {
      renderTextInput( true );
      renderPlacement( false );
    }
  }


  function renderTextInput( show ) {
    if ( show ) $monogramTextInput.show();
    else $monogramTextInput.hide();
  }

  function renderPlacement( show ) {
    if ( show ) {
      $monogramPlacementInput.show();
      $monogramPlacementInput.prev().show();
    } else {
      $monogramPlacementInput.hide();
      $monogramPlacementInput.prev().hide();
    }
  }

  function renderPrice() {
    if ( !currentPriceVariant ) return;
    $monogramPriceLabel.html( currentPriceVariant.price );
  }

  /**
   * Returns the appropiate monogramming variant depending on the
   * product tags and length of the text
   */
  function getActiveMonogrammingVariant() {
    console.warn('Get Monogrmaming Variant');
    // free monogramming promotion available
    if ( window.MonogrammingOptions.freeAvailable ) {
      if (window.MonogrammingOptions.freeOption === 'completely_free' && currentSelectedType == 'paint' ) {
      	return window.MonogrammingOptions.handpaintedByPrice[ 0 ];
      }

      if (window.MonogrammingOptions.freeOption === 'free_handpainted' && currentSelectedType == 'paint') {
      	return window.MonogrammingOptions.handpaintedByPrice[ 0 ];
      }

      if (window.MonogrammingOptions.freeOption === 'completely_free' && currentSelectedType != 'paint' ){
        return window.MonogrammingOptions.monogrammingVariantsByPrice[ 0 ];
      }

      if (window.MonogrammingOptions.freeOption === 'free_gold' && currentSelectedType != 'paint' ){
        return window.MonogrammingOptions.monogrammingVariantsByPrice[ 0 ];
      }
    }

    console.warn('Passed Free Portion');

    // handpainted price
    if ( currentSelectedType === 'paint' ) {
      // 1 letter is $50, then $25 per letter
      var textLength = removeSpaces( getSelectedMonoText() ).length;
      var price = window.MonogrammingOptions.handPaintedBasePrice + ( Math.max( 0, textLength - 1 ) * window.MonogrammingOptions.handPaintedAddPrice );

      return window.MonogrammingOptions.handpaintedByPrice[ price ];
    }

    // not handpainted and long text
    if ( currentSelectedType !== 'phrase' && removeSpaces( getSelectedMonoText() ).length > 4 ) {
      return window.MonogrammingOptions.monogrammingVariantsByPrice[ 75 ];
    }

    // Normal price
    return getGoldPriceObjectByName();
  }

  /**
   * Returns text without any spaces
   * @param  {String} text
   * @return {String}
   */
  function removeSpaces( text ) {
    return text.replace( /\s/g, '' );
  }

  /**
   * Returns the visible product name
   */
  function getProductName() {
    return $( 'input[name="monogram-product"]' ).val();
  }

  /**
   * Returns the selected font when user selected a font option,
   * the font associated with the selected phrase, or empty
   * if user selected handpainted.
   */
  function getSelectedMonoFont() {
    return currentSelectedType === 'font'
      ? $currentSelectedElement.val()
      : currentSelectedType === 'phrase'
        ? $currentSelectedElement.data( 'font' )
        : '';
  }

  /**
   * Returns the selected placement, or empty if no placement applicable
   */
  function getSelectedMonoPlacement() {
    return currentSelectedType !== 'font' ? '' : $monogramPlacementInput.val();
  }

  /**
   * Returns the selected handpainted option, or empty if not selected.
   */
  function getHandPainted() {
    return currentSelectedType !== 'paint' ? '' : $currentSelectedElement.val();
  }

  /**
   * Returns the selected font, or empty if no font selected
   */
  function getSelectedMonoText() {
    return currentSelectedType === 'phrase'
      ? $currentSelectedElement.val()
      : $monogramTextInput.val();
  }

  /**
   * Returns visible product SKU
   * @return {[type]} [description]
   */
  function getSKU(){
    return $( '[ref="sku-placeholder"]').attr('data-mono-sku-value');
  }

  /**
   * Adds monogram properties to base product
   */
  function insertBaseProductProperties(properties) {
    const form = document.getElementById('minicart-add-to-cart-form');

    // Remove previous entries
    const hiddenInputs = form.querySelectorAll(':scope > input[type=hidden');
    hiddenInputs.forEach( input => {
      if ( input.name.includes('properties') ) {
        form.removeChild(input);
      }
    });

    for (const [key, value] of Object.entries(properties)) {
      var input = document.createElement('input')
      input.type = 'hidden';
      input.name = key;
      input.value = value;
      input.classList.add('monogram-properties-hidden-field');
      form.appendChild(input);
    }
  }

  /**
   * Adds the monogram product to the cart
   */
  function submitMonogram( e ) {
    console.log( 'monogrammingOn:', monogrammingOn );

    if ( !monogrammingOn ) {
      const propertyFields = document.querySelectorAll('.monogram-properties-hidden-field');
      propertyFields.forEach(field => {
        field.remove();
      });
      return true;
    }

    e.preventDefault();
    e.stopImmediatePropagation(); // prevent ajax cart from firing

    // var font = getSelectedMonoFont();
    // var placement = getSelectedMonoPlacement();
    // var text = getSelectedMonoText();
    // var handpainted = getHandPainted();
    var productName = getProductName();
    var sku = getSKU();
    var uuid = REBASE.theme.UUIDv4.generate()
    var errors = [];

    let font = null;
    let placement = null;
    let text = null;
    let size = null;
    let color1 = null;
    let color2 = null;
    let embColor = null;
    let dropShadow = null;
    let graphic = null;

    if(activeTab === 'tab-gold-foil'){
      if(!goldInput.value && !goldPhraseSelect.value){
        errors.push('Missing text on gold foil monogram');
        $("input#gold-letter-input").focus();
        goldLabel.style.color = '#ff0000';
        block.innerText = 'Enter characters to view preview';
        previewBox.classList.add('center', 'alert');
        block.style.display = 'block';
        left.style.display = 'none';
        right.style.display = 'none';
      }
    } else if(activeTab === 'tab-hand-painting'){
      if(!HPInput.value){
        errors.push('Missing text on handpainted monogram');
        $("input#hp-letter-input").focus();
        HPLabel.style.color = '#ff0000';
        block.innerText = 'Enter characters to view preview';
        previewBox.classList.add('center', 'alert');
        block.style.display = 'block';
        left.style.display = 'none';
        right.style.display = 'none';
      }
    } else {
      let embType = document.querySelector('input[name="emb-type"]:checked');
      let isGraphic = embType && embType.value === 'graphic' ? true : false;
      if(!embroideryInput.value && !isGraphic ){
        embroideryLabel.style.color = '#ff0000';
        errors.push('Missing text on embroidery monogram');
        $("input#emb-letter-input").focus();
      }
    }

    if ( errors.length > 0 ) {
      console.error( 'Monogram ATC error', errors );
    } else {
      var quantity = 1;
      // var monogramVariantId = currentPriceVariant.vid;
      let computedPrice = 0;

      if(activeTab === 'tab-gold-foil'){
        computedPrice = computeGoldPrice();
        monogramVariantId = window.MonogrammingOptions.monogrammingVariantsByPrice[ computedPrice ].vid;
        let goldType = document.querySelector('input[name="gold-type"]:checked').value;
        if(goldType === 'initial'){
          text = goldInput.value;
          let fontVvalue = document.querySelector('input[name="font"]:checked').value;
          font = fontVvalue;
        } else {
          text = goldPhraseSelect.value;
          font = 'petit';
        }
        let placementText = $("#gold-placement option:selected").text();
        placement = placementText.substr(0, placementText.indexOf('(')); 
      } else if (activeTab === 'tab-hand-painting'){
        computedPrice = computeHPPrice();
        monogramVariantId = window.MonogrammingOptions.handpaintedByPrice[ computedPrice ].vid;
        text = HPInput.value;
        size = document.querySelector('input[name="size"]:checked').value;
        if(size === 'one_inch'){
          size = 'one inch';
        } else {
          size = 'two inch';
        }
        color1 = hpFirstColor.value;
        color2 = hpSecondColor.value;
        dropShadow = document.querySelector('input[name="shadow"]:checked').value;
        if(dropShadow === 'drop'){
          dropShadow = 'yes';
        } else {
          dropShadow = 'no';
        }
        let placementText = $("#hp-placement option:selected").text();
        placement = placementText.substr(0, placementText.indexOf('('));
      } else {
        // embroidery
        if (embroideryStyle == 'color') {
          embColor = document.getElementById('emb-color').value;
        } else if (embroideryStyle == 'combo') {
          embColor = document.getElementById('emb-combo').value;
        }
        computedPrice = computeEmbroideryPrice();
        monogramVariantId = window.MonogrammingOptions.embroideredByPrice[ computedPrice ].vid;
        text = embroideryInput.value;
        if(embroideryGraphic.style.display != 'none'){
          graphic = embroideryGraphic.value;
        }
        let placementText = $("#emb-placement option:selected").text();
        placement = placementText.substr(0, placementText.indexOf('('));
        font = embroideryFont.value;
        if(font === 'block_without_shadow'){
          font = 'block without shadow';
        }
      }

      var propertyObject = {}, urlParams;
      propertyObject['properties[_uuid]'] = uuid;
      propertyObject['properties[Item]'] = 'Final Sale';
      propertyObject['properties[_Product]'] = productName;

      if(font){
        propertyObject['properties[Font]'] = font.toUpperCase();;
      }
      if(text) {
        propertyObject['properties[Text]'] = text.toUpperCase();
      }
      if(placement) {
        propertyObject['properties[Placement]'] = placement.toUpperCase();
      }
      if(size) {
        propertyObject['properties[Size]'] = size.toUpperCase();
      }
      if(color1) {
        propertyObject['properties[FirstColor]'] = color1.toUpperCase();
      }
      if(color2) {
        propertyObject['properties[SecondColor]'] = color2.toUpperCase();
      }
      if (embColor) {
        propertyObject['properties[Color]'] = embColor.toUpperCase().replace('-', ' / ');
      }
      if(dropShadow) {
        propertyObject['properties[DropShadow]'] = dropShadow.toUpperCase();
      }
      if(graphic) {
        propertyObject['properties[Graphic]'] = graphic.toUpperCase();
      }
      propertyObject['properties[_SKU]'] = sku;
      if (timelinesJSON) {
        console.log(timelinesJSON);
        if (activeTab == 'tab-gold-foil') {
          propertyObject['properties[Note]'] = timelinesJSON.gold_foil_timeline;
        } else if (activeTab == 'tab-hand-painting') {
          propertyObject['properties[Note]'] = timelinesJSON.hand_painting_timeline;
        } else if (activeTab == 'tab-embroidery') {
          propertyObject['properties[Note]'] = timelinesJSON.embroidery_timeline;
        }
      }

      urlParams = new URLSearchParams(propertyObject);

      var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: `quantity=${quantity}&id=${monogramVariantId}&${urlParams.toString()}`,
        dataType: 'json',
        success: function( line_item ) {
          // set base product properties to match
          insertBaseProductProperties(propertyObject);

          // submit original product
          $( '#minicart-add-to-cart-form' ).unbind( 'submit.monogram' ).submit();
          $( '#minicart-add-to-cart-form' ).bindFirst( 'submit.monogram', submitMonogram );
          toggleModal();
        },
        error: function( xhr, status ) { console.error( status ); }
      };
      $.ajax( params );

      return true;
    }
  }

  function displayPrice(price) {
    const isoCurrency = window.MonogrammingOptions.isoCurrency;
    return isoCurrency ? `Price - ${Shopify.currency_symbol}${price} ${isoCurrency}` : `Price - ${Shopify.currency_symbol}${price}`;
  }

  function updateExamplesLink() {
    if ( examplesLink ) {
      if ( activeTab === 'tab-embroidery' ){
        examplesLink.setAttribute('href', examplesLink.dataset.embUrl);
        examplesLink.innerText = 'View Embroidery Examples';
      } else if (activeTab === 'tab-hand-painting'){
        examplesLink.setAttribute('href', examplesLink.dataset.hpUrl);
        examplesLink.innerText = 'View Hand Painting Examples';
      } else {
        examplesLink.setAttribute('href', examplesLink.dataset.gfUrl);
        examplesLink.innerText = 'View Gold Foil Examples';
      }
    }
  }

  function addColorSwatchesClickEvents() {
    const colorSwatches = document.querySelectorAll('.color-swatch');
    colorSwatches.forEach(swatch => {
      swatch.addEventListener('click', () => {
        const selectedColor = swatch.dataset.color;
        const swatchContainer = swatch.parentElement;
        const selectInputId = swatchContainer.dataset.select;
        const selectInput = document.getElementById(selectInputId);
        const displayLabel = document.getElementById(`${selectInputId}-display`);
        const shadowRadio = document.getElementById(`${selectInputId}-shadow`);

        // Refactor this in case of another drop shadow select being present.
        if ( shadowRadio && selectedColor === 'none' ) {
          const noDropShadow = document.getElementById('no-drop-shadow');
          noDropShadow.checked = true;
          noDropShadow.dispatchEvent(new Event('change'));
        } else {
          if ( shadowRadio ) {
            const dropShadow = document.getElementById('drop-shadow');
            dropShadow.checked = true;
            dropShadow.dispatchEvent(new Event('change'));
          }
          selectInput.value = selectedColor;
        }
        displayLabel.innerText = swatch.dataset.label;
        selectInput.dispatchEvent(new Event('change'));

        Array.from(swatchContainer.children).forEach(swatch => {
          swatch.classList.remove('selected');
          swatch.setAttribute('aria-selected', 'false');
        });

        swatch.classList.add('selected');
        swatch.setAttribute('aria-selected', 'true');
      });
    });
  }
}

// Expose the initializer so it can be re-fired after the product section is
// swapped in place (e.g. clicking a connected-product swatch). See
// MainProduct.js `reinitAfterSwap`.
window.initMonogramming = initMonogramming;

// Self-initialize. If the script is loaded after DOMContentLoaded has already
// fired (e.g. re-injected during a section swap), run immediately.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMonogramming);
} else {
  initMonogramming();
}